import { Trans } from '@lingui/react/macro';

import RefashionLogo from '@/components/RefashionLogo';
import {
  shouldShowWorkshopWarranty,
  WorkshopWarrantyExpirationDate,
} from '@/components/WorkshopWarrantyExpirationDate/WorkshopWarrantyExpirationDate';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import {
  computeDuplicateActionNumber,
  getRefashionStatus,
  useGetActionName,
} from '@/models/actionType';
import { isActionMandatory } from '@/models/article';
import { ArticleActionWithRelations, ArticleWithRelations } from '@/models/request';

import { WithContext } from './WithContext';

export const ActionName = ({
  action,
  isDisabled = false,
  article,
}: {
  action: ArticleActionWithRelations;
  isDisabled?: boolean;
  article: ArticleWithRelations;
}) => {
  const actions = article.snapshot.articleActions;
  const isMandatoryAction = isActionMandatory(action);
  const showWorkshopWarranty = shouldShowWorkshopWarranty(actions);

  const getActionName = useGetActionName();
  const duplicateNumber = computeDuplicateActionNumber(action, actions);

  return (
    <WithContext context={action.context}>
      <Stack row gap="4px">
        <Paragraph color={isDisabled ? 'disabled' : undefined}>
          {getActionName({ action })}
          {actions.length > 1 && duplicateNumber ? ` #${duplicateNumber}` : ''}
        </Paragraph>
        {getRefashionStatus(action.organizationPrice) === 'applied' && <RefashionLogo />}
      </Stack>
      {showWorkshopWarranty && (
        <WorkshopWarrantyExpirationDate
          workshopWarrantyExpirationDate={action.workshopWarrantyExpirationDate}
        />
      )}
      {!!action.parents.length && (
        <Paragraph size="200" weight="regular" color="secondary">
          <Trans id="client.article.services.child_action">
            This action is required to complete one or more other selected actions and is
            automatically included
          </Trans>
        </Paragraph>
      )}
      {!!isMandatoryAction && (
        <Paragraph size="200" weight="regular" color="secondary">
          <Trans id="client.article.services.mandatory_action">
            This action is mandatory and automatically included
          </Trans>
        </Paragraph>
      )}
    </WithContext>
  );
};
